<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M9.3 2.7c-1.8 0-3.5.7-4.7 2-1.3 1.3-2 2.9-2 4.7 0 1.8.7 3.5 2 4.7 1.3 1.3 2.9 2 4.7 2 1.8 0 3.5-.7 4.7-2 1.3-1.3 2-2.9 2-4.7 0-1.8-.7-3.5-2-4.7-1.2-1.3-2.9-2-4.7-2zM0 9.3C0 7.8.4 6.4 1 5c.7-1.3 1.6-2.5 2.8-3.3C5 .8 6.4.3 7.8 0c1.5-.2 3-.1 4.4.4C13.7.9 15 1.7 16 2.8c1 1.1 1.8 2.3 2.2 3.8.4 1.4.5 2.9.3 4.4-.2 1.5-.8 2.8-1.7 4l6.8 6.8c.3.2.4.6.4.9 0 .4-.1.7-.4.9-.2.3-.6.4-.9.4-.4 0-.7-.1-.9-.4L15 16.8c-1.4 1-3 1.7-4.8 1.8-1.7.2-3.5-.2-5-1s-2.9-2-3.8-3.4C.5 12.8 0 11.1 0 9.3z"
    />
  </svg>
</template>
